// extracted by mini-css-extract-plugin
export default {"chart1":"Bar_chart1__vk90c","chart2":"Bar_chart2__KUbFx","cardClass1":"Bar_cardClass1__b2BoD","cardClass2":"Bar_cardClass2__oSoXt"};